import { getUrl, getUrlSearch, setUrl } from '@fe/utils'
import axios from 'axios'
import ClipboardJS from 'clipboard'
import * as Browser from './browser'
import { checkOpen, evokeByIframe, evokeByLocation, evokeByTagA } from './evoke'

// 乐弧
// https://apps.apple.com/app/apple-store/1587662715

// 旅购
// https://apps.apple.com/app/apple-store/1530788774

// scheme 文档
// https://xjs3ti3gwc.feishu.cn/wiki/wikcnyGpin4kyDshdDtXhaAxXmc#R9LLQ1

// 示例
// https://evt.cdfsunrise.com/r/skip/?page=item&goodsId=61c099d4cfde4c00018d98ce&source_from=productshare&deploy_env=qa&originFrom=ios
// https://evt-pre.cdfsunrise.com/r/skip/?page=web&url=https%3A%2F%2Fevt-pre.cdfsunrise.com%2Fr%2Fpage%2F%3Fid%3D6270cba9b788450001a3908d%26debug%3D1&source_from=webpageshare&deploy_env=pre&originFrom=ios

const MOCK_APK = ``
const IOS_APPLE_ID = `1587662715`
const UNIVERSAL_DOMAIN = `https://app.cdfsunrise.com`
const PACKAGE = 'com.cdfsunrise.cdflehu'
const SOURCE = getUrl(location.href, 'source_from') || 'N/A'
const APP_STORE_ADDRESS = `https://itunes.apple.com/app/apple-store/id${IOS_APPLE_ID}?mt=8&pt=${SOURCE}&ct=${SOURCE}`
const CURRENT_VERSION = '1.3.4'

const doCheckOpen = (timeout: number, failure: () => void): void => {
  return checkOpen(() => {
    failure()
  }, timeout)
}

export type GetOpenAppOptionParams = {
  timeout?: number
  debug?: boolean
  PACKAGE?: string
  SOURCE?: string
  DEF_ENCODE_TARGET?: string
  DEF_APK_URL?: string
  APP_STORE_ADDRESS?: string
}

export type OpenType = {
  type: 'web' | 'native'
  query: Record<string, string>
}

export default class OpenApp {
  private readonly options: GetOpenAppOptionParams
  constructor(options: GetOpenAppOptionParams) {
    this.options =
      Object.assign(this.options || {}, { SOURCE, APP_STORE_ADDRESS, DEF_ENCODE_TARGET: this.getDefTarget(), PACKAGE, UNIVERSAL_DOMAIN, ...options }) ||
      ({
        timeout: 2000,
      } as GetOpenAppOptionParams)
    this.init()
  }

  async init() {
    const info = await axios.post(
      'https://api.cdfsunrise.com/restapi/search/version',
      {
        currentVersion: CURRENT_VERSION,
      },
      {
        headers: {
          appVersion: CURRENT_VERSION,
          UserSystem: 'H5',
        },
      }
    )
    if (info?.data) {
      this.options.DEF_APK_URL = MOCK_APK || info?.data?.downloadUrl
    }
  }
  getDefTarget(PAGE?: string) {
    const urlParams = getUrlSearch(location.href)
    const page = PAGE || urlParams?.page || 'home'
    const searchParams = {
      ...urlParams,
      page,
    }
    return {
      target: setUrl(`cdfsunrise://lehu/${page}`, { ...searchParams }),
      searchParams,
    }
  }
  /**
   * iOS APP bug
   * 如果通过universal link 打开了页面，又有粘贴板信息，iOS APP打开了两个同样的页面。
   * @param e
   */
  _triggerCopy(e?: TouchEvent) {
    // 暂时没用到的重要功能
    return null
    if (e) {
      const btn = (e.currentTarget || e.target) as any
      if (btn) {
        if (btn) {
          const copyTxt = this.getCopyInfo()
          console.log('copyTxt', copyTxt)

          let fakeElement = btn.querySelector('button.fake-copy')
          if (fakeElement) {
            fakeElement.parentNode.removeChild(fakeElement)
          }
          fakeElement = document.createElement('button')
          fakeElement.setAttribute('class', 'fake-copy')
          fakeElement.setAttribute('style', 'height:0;width:0;overflow:hidden;border:0;display:inline;padding:0;margin:0;')
          fakeElement.dataset.clipboardText = copyTxt
          btn.appendChild(fakeElement)

          const cp = new ClipboardJS(fakeElement, {
            text: function () {
              return copyTxt
            },
            action: function () {
              return 'copy'
            },
          })
          cp.on('success', function (ce: ClipboardJS.Event) {
            console.log('success', ce)
          })
          cp.on('error', function (ce: ClipboardJS.Event) {
            console.log('error', ce)
          })

          const event = document.createEvent('HTMLEvents')

          event.initEvent('click', false, true)
          fakeElement.dispatchEvent(event)
        }
      }
    }
  }

  getCopyInfo(): string {
    let infoData: any = {}

    if (this.options.debug) {
      console.log('getCopyInfo options debug', this.options)
    }

    infoData = {
      info: 'N/A',
    }

    return JSON.stringify(infoData)
  }

  getOpenAppOptionParams = (): GetOpenAppOptionParams => {
    if (typeof document === 'undefined') {
      return {} as any
    }

    const obj: GetOpenAppOptionParams = {
      timeout: this.options.timeout,
      PACKAGE: this.options.PACKAGE,
      SOURCE: this.options.SOURCE,
      DEF_ENCODE_TARGET: this.options.DEF_ENCODE_TARGET,
      DEF_APK_URL: this.options.DEF_APK_URL,
      APP_STORE_ADDRESS: this.options.APP_STORE_ADDRESS,
    }

    if (this.options.debug) {
      console.log('getOptionParams debug', obj)
    }
    return obj
  }
  openAndroidAppStore = (): void => {
    evokeByLocation(this.options.DEF_APK_URL)
  }
  openIosAppStore = (): void => {
    evokeByLocation(this.options.APP_STORE_ADDRESS)
  }
  open = (openparams = {} as OpenType, e?: TouchEvent) => {
    if (typeof document === 'undefined') {
      return
    }

    const page = openparams?.type
    let { target, searchParams } = this.getDefTarget(page)

    if (openparams.query) {
      searchParams = {
        ...searchParams,
        ...openparams.query,
      }
    }

    target = setUrl(target, searchParams)

    if (Browser.isAndroid) {
      // 安卓临时方案，去除https://
      target = target.replace('url=https%3A%2F%2F', `url=`)
    }

    this.options.DEF_ENCODE_TARGET = target

    const { timeout = 2000 } = this.options

    let failUrl = this.options.DEF_APK_URL
    if (Browser.isIos) {
      failUrl = this.options.APP_STORE_ADDRESS
    }

    const logInfo = this.getOpenAppOptionParams()
    console.log('logInfo', logInfo)

    if (Browser.isIos) {
      this._triggerCopy(e)
      // ios qq 禁止了 universalLink 唤起app，安卓不受影响 - 18年12月23日
      // ios qq 浏览器禁止了 universalLink - 19年5月1日
      // ios 微信自 7.0.5 版本放开了 Universal Link 的限制
      // ios 微博禁止了 universalLink
      // 进入页面后，夸克浏览器自行打开 appstore，导致无法追加粘贴板信息
      if (Browser.isWeibo) {
        evokeByLocation(this.options.APP_STORE_ADDRESS)
      } else if (Browser.isQuark) {
        evokeByLocation(this.options.APP_STORE_ADDRESS)
      } else if (Browser.isQQ || Browser.isQQBrowser || Browser.isQzone) {
        if (location.href.includes(UNIVERSAL_DOMAIN)) {
          // https://app.cdfsunrise.com
          evokeByLocation(this.options.APP_STORE_ADDRESS)
        } else {
          // https://download.cdfsunrise.com
          // ios scheme
          evokeByTagA(this.options.DEF_ENCODE_TARGET)
          doCheckOpen(timeout, () => {
            evokeByLocation(this.options.APP_STORE_ADDRESS)
          })
        }
      } else {
        // ios 标准浏览器内
        if (location.href.includes(UNIVERSAL_DOMAIN)) {
          // 必然是ios
          evokeByLocation(this.options.APP_STORE_ADDRESS)
        } else {
          const params: Record<string, any> = {
            popAppStore: 1,
            ...searchParams,
          }

          const urls = setUrl(`${UNIVERSAL_DOMAIN}${location.pathname}`, params)

          window.location.href = urls
        }
      }
    } else {
      this._triggerCopy(e)
      // 安卓的混乱世界
      if (Browser.isWechat) {
        // 安卓微信环境，勿删注释
        // const tmp = setUrl(yingyongbao, Browser.isAndroid ? 'android_schema' : 'ios_scheme', encodeURIComponent(DEF_ENCODE_TARGET))
        // evokeByLocation(tmp)
        // 安卓在微信里面，不要废话，直接在业务中弹出有蒙层，提示去浏览器打开。
        // 理论上，微信安卓环境只会是蒙层，提示浏览器打开，不可能调用open方法。
        console.error('在【微信】&【安卓】中，所有的下载，请在业务中直接提示去右上角，用浏览器打开页面')
      } else if (Browser.isOriginalChrome) {
        console.log('isOriginalChrome')
        const tmp = setUrl(this.options.DEF_ENCODE_TARGET, {}).replace('cdfsunrise://lehu', 'intent://lehu')
        const intentStr = `${tmp}#Intent;package=${this.options.PACKAGE};scheme=cdfsunrise;S.browser_fallback_url=${encodeURIComponent(failUrl)};end;`
        console.log('intentStr', intentStr)
        console.log('intentStrArr', intentStr.split(';'))
        evokeByLocation(intentStr)
      } else if (Browser.isBaidu || Browser.isWeibo || Browser.isQzone) {
        console.log('Browser.isBaidu || Browser.isWeibo || Browser.isQzone')
        evokeByLocation(failUrl)
      } else if (Browser.isQQBrowser) {
        console.log('isQQBrowser')
        // QQ 浏览器
        evokeByLocation(this.options.DEF_ENCODE_TARGET)
        doCheckOpen(timeout, () => {
          evokeByLocation(failUrl)
        })
      } else if (Browser.isUCBrowser) {
        console.log('isUCBrowser')
        // UC 浏览器
        evokeByIframe(this.options.DEF_ENCODE_TARGET) // 小米 6 打开，会空白
        doCheckOpen(timeout, () => {
          evokeByLocation(failUrl)
        })
      } else {
        console.log('Browser.other', failUrl)
        evokeByIframe(this.options.DEF_ENCODE_TARGET)
        doCheckOpen(timeout, () => {
          evokeByLocation(failUrl)
        })
      }
    }
  }
}

export { IOS_APPLE_ID, PACKAGE, UNIVERSAL_DOMAIN, APP_STORE_ADDRESS, Browser }
